/**
 * Created by nakajima on 2016/12/13.
 */
import { Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Comp } from '../../models/component/component';
import { NotFoundComponent } from '../notfound/notfound.component';
import { TopComponent } from '../top/top.component';
import { GridComponent } from '../grid/grid.component';
import { DivComponent } from '../div/div.component';
import { FilterComponent } from '../filter/filter.component';
import { HrComponent } from '../hr/hr.component';
import { LabelComponent } from '../label/label.component';
import { NaviComponent } from '../navi/navi.component';
import { ButtonComponent } from '../button/button.component';
import { EntryComponent } from '../entry/entry.component';
import { ViewComponent } from '../view/view.component';
import { EditMessagesComponent } from '../editmessages/editmessages.component';
import { SearchComponent } from '../list/search.component';
import { ListCountComponent } from '../list/count.component';
import { RowsComponent } from '../list/rows.component';
import { ListComponent } from '../list/list.component';
import { PagerComponent } from '../list/pager.component';
import { ListGroupComponent } from '../list/listgroup.component';
import { CsvComponent } from '../list/csv.component';
import { BulkComponent } from '../list/bulk.component';
import { TreeComponent } from '../tree/tree.component';
import { UnitComponent } from '../unit/unit.component';
import { AccessUnitComponent } from '../unit/accessunit.component';
import { ScopeComponent } from '../unit/scope.component';
import { MemberSearchComponent } from '../member_search/member_search.component';
import { CampaignNaviComponent } from '../campaign/campaign-navi.component';
import { CampaignStepComponent } from '../campaign/campaign-step.component';
import { CampaignGoalComponent } from '../campaign/campaign-goal.component';
import { CampaignSegmentComponent } from '../campaign/campaign-segment.component';
import { CampaignMeasureComponent } from '../campaign/campaign-measure.component';
import { CampaignContentsComponent } from '../campaign/campaign-contents.component';
import { CampaignTimingComponent } from '../campaign/campaign-timing.component';
import { CampaignConfirmComponent } from '../campaign/campaign-confirm.component';
import { CampaignReportComponent } from '../campaign/campaign-report.component';
import { ItemSubItemComponent } from '../item/item-subitem.component';
import { ItemCategoryTreeComponent } from '../item/item-category-tree.component';
import { ItemCategoryTreeCheckComponent } from '../item/item-category-tree-check.component';
import { ItemPeriodComponent } from '../item/item-period.component';
import { ItemPriceComponent } from '../item/item-price.component';
import { ItemImageComponent } from '../item/item-image.component';
import { SortComponent } from '../sort/sort.component';
import { SortTreeComponent } from '../sort/sort-tree.component';
import { TabGroupComponent } from '../tab/tab.component';
import { InquiryComponent } from '../inquiry/inquiry.component';
import { RegistryCondComponent } from '../registry/registry-cond.component';
import { RegistryPointComponent } from '../registry/registry-point.component';
import { QuestionnaireComponent } from '../questionnaire/questionnaire.component';
import { QuestionnaireAnswerComponent } from '../questionnaire/questionnaire-answer.component';
import { MailDeliveryComponent } from '../mail_delivery/mail-delivery.component';
import { QuestionnaireAggregateComponent } from '../questionnaire/questionnaire-aggregate.component';
import { TemplateComponent } from '../template/template.component';
import { TemplateValueComponent } from '../template/template-value.component';
import { ImportErrorComponent } from '../import/import-error.component';
import { AddRowComponent } from '../addrow/addrow.component';
import { ToggleComponent } from '../toggle/toggle.component';
import { ModalComponent } from '../modal/modal.component';
import { MultiUploadComponent } from '../upload/multi-upload.component';
//// kts
import { ktsComponents } from '../../projects/kts/component/content/content.component';
var components = {
    NotFoundComponent: NotFoundComponent,
    TopComponent: TopComponent,
    GridComponent: GridComponent,
    DivComponent: DivComponent,
    FilterComponent: FilterComponent,
    HrComponent: HrComponent,
    LabelComponent: LabelComponent,
    NaviComponent: NaviComponent,
    ButtonComponent: ButtonComponent,
    EntryComponent: EntryComponent,
    ViewComponent: ViewComponent,
    EditMessagesComponent: EditMessagesComponent,
    SearchComponent: SearchComponent,
    ListCountComponent: ListCountComponent,
    RowsComponent: RowsComponent,
    ListComponent: ListComponent,
    PagerComponent: PagerComponent,
    ListGroupComponent: ListGroupComponent,
    CsvComponent: CsvComponent,
    BulkComponent: BulkComponent,
    TreeComponent: TreeComponent,
    UnitComponent: UnitComponent,
    AccessUnitComponent: AccessUnitComponent,
    ScopeComponent: ScopeComponent,
    MemberSearchComponent: MemberSearchComponent,
    CampaignNaviComponent: CampaignNaviComponent,
    CampaignStepComponent: CampaignStepComponent,
    CampaignGoalComponent: CampaignGoalComponent,
    CampaignSegmentComponent: CampaignSegmentComponent,
    CampaignMeasureComponent: CampaignMeasureComponent,
    CampaignContentsComponent: CampaignContentsComponent,
    CampaignTimingComponent: CampaignTimingComponent,
    CampaignConfirmComponent: CampaignConfirmComponent,
    CampaignReportComponent: CampaignReportComponent,
    ItemSubItemComponent: ItemSubItemComponent,
    ItemCategoryTreeComponent: ItemCategoryTreeComponent,
    ItemCategoryTreeCheckComponent: ItemCategoryTreeCheckComponent,
    ItemPeriodComponent: ItemPeriodComponent,
    ItemPriceComponent: ItemPriceComponent,
    ItemImageComponent: ItemImageComponent,
    SortComponent: SortComponent,
    SortTreeComponent: SortTreeComponent,
    TabGroupComponent: TabGroupComponent,
    InquiryComponent: InquiryComponent,
    RegistryCondComponent: RegistryCondComponent,
    RegistryPointComponent: RegistryPointComponent,
    QuestionnaireComponent: QuestionnaireComponent,
    QuestionnaireAnswerComponent: QuestionnaireAnswerComponent,
    QuestionnaireAggregateComponent: QuestionnaireAggregateComponent,
    MailDeliveryComponent: MailDeliveryComponent,
    TemplateComponent: TemplateComponent,
    TemplateValueComponent: TemplateValueComponent,
    ImportErrorComponent: ImportErrorComponent,
    AddRowComponent: AddRowComponent,
    ToggleComponent: ToggleComponent,
    ModalComponent: ModalComponent,
    MultiUploadComponent: MultiUploadComponent
};
var ContentComponent = /** @class */ (function () {
    function ContentComponent(router, resolver, ref, route, logger) {
        this.router = router;
        this.resolver = resolver;
        this.ref = ref;
        this.route = route;
        this.logger = logger;
        this.afterView = new EventEmitter();
        this.comp = null;
    }
    ContentComponent.prototype.ngOnInit = function () {
        this.logger.debug('component:', this.component);
        if (this.comp != null) {
            this.comp.destroy();
        }
        var comps = this.getComponents();
        if (typeof this.component.component !== 'undefined' && this.component.component in comps) {
            this.comp = this.ref.createComponent(this.resolver.resolveComponentFactory(comps[this.component.component]), 0);
            if (typeof this.comp.instance.setCompData === 'function') {
                this.comp.instance.setCompData(this.component.name, this.component);
            }
        }
        else {
            this.comp = this.ref.createComponent(this.resolver.resolveComponentFactory(NotFoundComponent), 0);
        }
    };
    ContentComponent.prototype.ngAfterViewInit = function () {
        this.afterView.emit();
    };
    ContentComponent.prototype.getComponents = function () {
        return Object.assign({}, components, ktsComponents);
    };
    ContentComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'content',
                    template: ''
                }] }
    ];
    /** @nocollapse */
    ContentComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ComponentFactoryResolver },
        { type: ViewContainerRef },
        { type: ActivatedRoute },
        { type: NGXLogger }
    ]; };
    ContentComponent.propDecorators = {
        component: [{ type: Input }],
        afterView: [{ type: Output }]
    };
    return ContentComponent;
}());
export { ContentComponent };
//# sourceMappingURL=content.component.js.map